<template>
    <div class="col-12 q-mb-md">
        <q-banner
            v-if="show"
            class="q-pl-none bg-white border-grey"
            rounded
            inline-actions
        >
            <div class="row items-center no-wrap">
                <div>
                    <q-icon
                        name="fa fa-exclamation-circle"
                        color="primary"
                        size="2.5rem"
                        class="q-pa-sm"
                    ></q-icon>
                </div>
                <div class="fontStyle">
                    {{ bannerMessage }}
                    <a :href="learnMoreURL" target="_black">
                        {{ $t('Learn more') }}
                    </a>
                </div>
            </div>
        </q-banner>
    </div>
</template>

<script>
export default {
    name: 'WarningBanner',
    props: {
        show: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            learnMoreURL:
                'https://help.iotorq-lean.com/hc/en-us/articles/360051204974-Manage-downtime-Causes-and-Categories',
            bannerMessage: this.$t(
                'Downtime events with a "Planned shutdown" type of loss are excluded from any OEE calculations and won\'t be visible in the KPI and Loss reports.'
            )
        };
    }
};
</script>

<style scoped>
.fontStyle {
    color: black;
    padding: '1%';
    font-weight: 300;
}
</style>
